import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import './global.css'

// Default title and description
const DEFAULT_TITLE = 'InforceIQ'
const DEFAULT_DESC =
  "Gena is InforceIQ's public client link surface for token-scoped intake and transaction flows."

// Initialize title and meta description
document.title = DEFAULT_TITLE
const descriptionMeta = document.querySelector('meta[name="description"]')
if (descriptionMeta) descriptionMeta.setAttribute('content', DEFAULT_DESC)

// Update title on route changes using route meta.title
router.afterEach((to) => {
  const title = (to.meta && (to.meta as any).title) || DEFAULT_TITLE
  if (typeof title === 'string' && title.trim()) {
    document.title = title
  } else {
    document.title = DEFAULT_TITLE
  }
})

const app = createApp(App)
const pinia = createPinia()

app.use(pinia)
app.use(router)
app.mount('#app')
